<template>
    <div>
        <sys-register-base 
            :loading="loading" 
            @onSave="save" 
            :model.sync="model" 
            :title="title" 
            icon="mdi-book-open-page-variant" 
            v-bind:show.sync="dialog"
            maxWidth="40%"
            textButtonSave="Gerar Diários"
        >
        <template v-slot:form>

            <!-- <div id="map"></div> -->
            <v-container>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <sys-select-company
                                :model.sync="model.companies"
                                label="Empresa (Opcional)"
                                multiple
                                dense
                                select-all
                                filter-time-sheet
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="8">
                            <sys-select-campus
                                :model.sync="model.campuses"
                                :error="errors.length > 0"  
                                :errors="errors.campuses"
                                label="Campus*"
                                multiple
                                only-active
                                select-all
                                autofocus
                                filter-relation="groups"
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <sys-select-shift
                                :model.sync="model.shifts"
                                :error="errors.length > 0"  
                                :errors="errors.shifts"
                                label="Turno*"
                                multiple
                                only-active
                                select-all
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <sys-select-occurrence-sheet-type
                                :model.sync="model.types"
                                :error="errors.length > 0"  
                                :errors="errors.types"
                                label="Tipo*"
                                dense
                                multiple
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field 
                                v-model="model.year" 
                                :error="errors.length > 0" 
                                :error-messages="errors.year" 
                                label="Ano*"
                                disabled
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <sys-select-month 
                                :model.sync="model.month"
                                dense
                                :error="errors.length > 0" 
                                :errors="errors.month"
                                label="Mês*"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="model.consolidate_campuses"     
                                text-helper='Consolidar todos os campus na folha de ponto' 
                                label="Consolidar Campus"
                                inset
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="model.consolidate_shifts"     
                                text-helper='Consolidar todos os turnos na folha de ponto' 
                                label="Consolidar Turno"
                                inset
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="model.include_ranges"     
                                text-helper='Incluir intervalos' 
                                label="Intervalo"
                                inset
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="model.consolidade_dates"     
                                text-helper='Consolidar horários por data' 
                                label="Consolidar Datas"
                                inset
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="model.show_holidays"     
                                text-helper='Exibir feriados no ponto do professor' 
                                label="Feriado"
                                inset
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="model.create_only_new"     
                                text-helper='Gerar folhas de ponto apenas para novos registros (ignorar professores que já possuem folhas criadas para o período)' 
                                label="Gerar novos registros"
                                inset
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <sys-select-teacher
                                :model.sync="model.teacher_id"
                                :error="errors.teacher_id && errors.length > 0" 
                                :data.sync="model.teacher"
                                :errors="errors.teacher_id"
                                :companyIds="selectedCompanyIds"
                                label="Professor (Opcional - Deixar vazio para gerar de todos)"
                                autoComplete
                                clearable
                            />
                        </v-col>
                    </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
       
    </sys-register-base>

    <!-- Dialog para exibir professores com folhas assinadas (erro - bloqueio) -->
    <v-dialog v-model="showSignedDialog" max-width="600" scrollable>
        <v-card>
            <v-card-title class="error white--text">
                <v-icon left color="white">mdi-alert</v-icon>
                Folhas de Ponto Assinadas
            </v-card-title>
            <v-card-text class="pt-4">
                <p>Os seguintes professores possuem folhas com assinatura em andamento ou finalizadas e não podem ser regeneradas:</p>
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th scope="col" class="text-left">Professor</th>
                                <th scope="col" class="text-left">Status da Assinatura</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="sheet in signedSheets" :key="sheet.teacher_id">
                                <td>{{ sheet.teacher_name }}</td>
                                <td>
                                    <v-chip small :color="sheet.sign_status === 'Documento Assinado' ? 'success' : 'warning'" dark>
                                        {{ sheet.sign_status }}
                                    </v-chip>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="showSignedDialog = false">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Dialog para exibir folhas ignoradas (aviso - lote com sucesso) -->
    <v-dialog v-model="showSkippedDialog" max-width="600" scrollable>
        <v-card>
            <v-card-title class="warning white--text">
                <v-icon left color="white">mdi-information</v-icon>
                Processo Iniciado com Aviso
            </v-card-title>
            <v-card-text class="pt-4">
                <v-alert type="success" dense class="mb-4">
                    O processo de geração foi iniciado com sucesso!
                </v-alert>
                <p>Os seguintes professores possuem folhas assinadas e foram <strong>ignorados</strong> (suas folhas não serão alteradas):</p>
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th scope="col" class="text-left">Professor</th>
                                <th scope="col" class="text-left">Status da Assinatura</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="sheet in skippedSheets" :key="sheet.teacher_id">
                                <td>{{ sheet.teacher_name }}</td>
                                <td>
                                    <v-chip small color="success" dark>
                                        {{ sheet.sign_status }}
                                    </v-chip>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="showSkippedDialog = false">Entendi</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: "SysOccurrenceSheetAllRegister",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
        model: {},
        showSignedDialog: false,
        signedSheets: [],
        showSkippedDialog: false,
        skippedSheets: [],
    }),
    created(){
        
    },

    computed: {
      ...mapState('auth', ['acesso']),
      selectedCompanyIds() {
          return this.model.companies 
              ? this.model.companies.map(c => c.id) 
              : []
      }
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                
                this.error = false;
                this.errors = {};
                this.model = {};

                this.model.year         = this.acesso.periodo.year;
                this.model.types        = [{ id: 1, name: 'Aula'}, { id: 2, name: 'Atividades'}];
                //this.model.date_start   = this.acesso.periodo.classes_start;
                //this.model.date_end     = this.acesso.periodo.classes_end;

                if(this.isAnima()){
                    this.model.consolidate_campuses = true;
                    this.model.consolidate_shifts = true;
                    this.model.consolidade_dates = true;
                    this.model.include_ranges = true;
                    this.model.show_holidays = true;
                    this.model.create_only_new = true;
                }
                
                
            }
        },
        
    },
    props: {
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-alert"
        },
        title: {
            type: String,
            default: "Marcações de Ponto"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('timeSheet', ['ActionStoreOccurrenceSheetAll']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;
            var payload = {};

            Object.assign(payload, this.model);
            payload.companies = this.model.companies ? this.model.companies.map(c => ({ id: c.id })) : [];
            payload.campuses = this.model.campuses ? this.model.campuses.map(c => ({ id: c.id })) : [];
            payload.shifts = this.model.shifts ? this.model.shifts.map(c => ({ id: c.id })) : [];

            this.ActionStoreOccurrenceSheetAll(payload)
            .then((res) => {
                this.message = res.message;
                
                // Verificar se há folhas ignoradas (processamento em lote com assinadas)
                if (res.skipped_sheets && res.skipped_sheets.length > 0) {
                    this.skippedSheets = res.skipped_sheets;
                    this.showSkippedDialog = true;
                }
                
                this.$emit('onCompleted', res.data);
            })
            .catch((error) =>{
                // Verificar se é erro de folhas assinadas
                if (error.errors && error.errors.signed_sheets && error.errors.signed_sheets.length > 0) {
                    this.signedSheets = error.errors.signed_sheets;
                    this.showSignedDialog = true;
                } else {
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                }
            })
            .finally(() => {
                this.loading = false;
            })
            

            
        },

    }
}
</script>